import SamePage, {ConditionParams} from './_same-page';

interface CoupledParams {
    SubConditions: ConditionParams[],
    Junctor: 'AND' | 'OR',
}

export default function () {
    $(function () {
        /**
         * Client side show condition for SamePageCoupled elements.
         */
        $('.js-same-page-coupled').each(function () {
            const $targetElement = $(this); // Element to be shown or hidden
            const params: CoupledParams = $(this).data('condition-params');

            SamePage.hideTargetElement($targetElement);
            if (isConditionTrue(params)) {
                SamePage.showTargetElement($targetElement);
            }
            // Change target element when source element changes
            for (let key in params.SubConditions) {
                const subCondition = params.SubConditions[key];
                // noinspection DuplicatedCode
                const $sourceElements = SamePage.getInputElementsByItemID(subCondition.ItemID);
                $sourceElements.each(function () {
                    const $sourceElement = $(this);
                    $sourceElement.on('change', function () {
                        if (isConditionTrue(params)) {
                            SamePage.showTargetElement($targetElement);
                        } else {
                            SamePage.hideTargetElement($targetElement);
                            SamePage.resetInputField($targetElement); // Delete previously entered data
                        }
                    });
                });
            }
        });
    });
}

function isConditionTrue(params: CoupledParams): boolean {
    const allSubConditionsMustBeTrue = params.Junctor === 'AND';
    let result = null;
    for (let key in params.SubConditions) {
        const subCondition = params.SubConditions[key],
            conditionItemID = subCondition.ItemID;

        const $sourceElements = SamePage.getInputElementsByItemID(conditionItemID);
        $sourceElements.each(function () {
            if (SamePage.hasValue($(this))) {
                const isSubConditionTrue = SamePage.conditionFunction(subCondition, <string>$(this).val());
                if (!isSubConditionTrue && allSubConditionsMustBeTrue) {
                    result = false;
                    return false; // Break the each-loop
                }
                if (isSubConditionTrue && !allSubConditionsMustBeTrue) {
                    result = true;
                    return false; // Break the each-loop
                }
            }
        });
        if (result !== null) {
            return result;
        }
    }
    return allSubConditionsMustBeTrue;
}